import React from "react";
import StatCards from "./statCards";
import BlankPage from "./blank";
import SortbyDate from "./sortByDate";
import SortProjects from "./sortProjects";
import CallReport from "./callReport";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { useNavigate } from "react-router";
import { NotificationPopUp } from "../settings";

export default function DashboardModule({ isEmpty }: { isEmpty?: boolean }) {
  const navigate = useNavigate();
  return (
    <div className="w-full">
      {/*  <NotificationPopUp /> */}
      <div className="flex flex-row flex-wrap gap-[18px] mb-[18px]">
        <SortProjects />
        <SortbyDate />
        <div className="ml-auto">
          <ActionIcon
            variant="text"
            className="self-end h-[34px] w-fit rounded-[4px] border-[.5px] border-muted py-[10px] px-[16px] gap-[4px] bg-btn mb-[22px] hover:text-background text-background"
            onClick={() => navigate("/campaigns/new")}
          >
            <Text className="font-[400] font-gilroyMedium text-[12px] leading-[14.56px]">
              Create campaign
            </Text>
          </ActionIcon>
        </div>
      </div>
      <StatCards
        className="grid md:grid-cols-2 lg:grid-cols-4 grid-flow-row mb-[36px]"
        empty={isEmpty}
      />
      <CallReport empty={isEmpty} />
    </div>
  );
}
